import type { ActionContext } from 'vuex'

import type { CoreState } from '@/core/store/types'
import { type Brand } from '@/core/types'
import { OlympusClient } from '@/OlympusClient'

export interface UpdateBrandParams {
  brandId: string
  update: Partial<Brand>
}

export const updateBrand = async (
  { commit }: ActionContext<CoreState, unknown>,
  { brandId, update }: UpdateBrandParams
): Promise<void> => {
  const brand = await OlympusClient.brandsV0.brand.updateBrand({
    body: update,
    params: {
      brandId,
    },
  })

  commit('SET_BRAND', brand)
}
